// Home
import { Message } from 'element-ui';
import { findCarInfoByType, personalQuotation } from "@/api/V2";
import { findAuctionCarInfo } from "@/api/auctionVehicles";
import { getCarList } from "@/api/CarDetail";
const state = {
    BASEURL: process.env.VUE_APP_BASE_URL,
    listValueInfo: [],
    isLoading: false,
    total: 0,
    // 车辆拍卖会id
    carAuctionId: null,
    // 存储汽车详情数据
    carDetail: null,
    // 汽车详情，侧边栏数据存储
    carDetailSide: [],
    carByLoading: false,
    // 是否还有更多
    hasMore: false,
    // 存储当前车辆详情信息 目的是为了里面的 isAuction字段 是否可以拍卖
    // carDetailInfo: null
}
// 修改state数据
const mutations = {
    GETALLCARBYTYPE(state, payload) {
        state.listValueInfo = payload
    },
    SET_LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_TOTAL(state, payload) {
        state.total = payload
    },
    // 修改车辆拍卖会id
    SET_CAR_AUCTION_ID(state, payload) {
        state.carAuctionId = payload
    },
    GET_CAR_DETAIL(state, payload) {
        state.carDetail = payload
    },
    // 存储侧边栏数据
    GET_CAR_DETAIL_SIDE(state, payload) {
        state.carDetailSide = payload
    },

    SET_CAR_BY_LOADING(state, payload) {
        state.carByLoading = payload
    },
    // 是否还有更多
    SET_HAS_MORE(state, payload) {
        state.hasMore = payload
    }
    // 存储当前车辆详情信息 目的是为了里面的 isAuction字段 是否可以拍卖
    // GET_CAR_DETAIL_INFO(state, payload) {
    //     state.carDetailInfo = payload

    // }

}
/**
 * 查询车辆相关信息
 * handleGetAllCarByType： 待交款 待提车 带过户 已过户
 * handleGetCarDetail： 已报价
 */
const actions = {
    async handleGetAllCarByType({ commit }, payload) {
        console.log(payload, 'payload');

        let apiFun = payload.status == 1 ? personalQuotation : findCarInfoByType
        commit('SET_CAR_BY_LOADING', true);
        try {
            let res = await apiFun({ type: payload.type, currentPage: payload.currentPage, pageSize: payload.pageSize })
            if (res.success) {
                let listValue = res.pageInfo.list.map(item => {
                    // 现在的carImg是字符串是用逗号隔开的，需要转换成数组
                    return {
                        ...item,
                        imgs: item.carImg?.split(',') || []
                    }
                }).slice(0, payload.pageSize)
                // 存储信息
                commit('GETALLCARBYTYPE', listValue);
                if ((payload.currentPage * payload.pageSize) >= res.pageInfo.total) {
                    commit('SET_HAS_MORE', true)
                } else {
                    commit('SET_HAS_MORE', false)
                }
            } else {
                commit('GETALLCARBYTYPE', []);
                commit('SET_HAS_MORE', false);
            }
        } finally {
            commit('SET_CAR_BY_LOADING', false);
            commit('SET_HAS_MORE', false);
        }
    },
    // 存储汽车详情
    async handleGetCarDetail({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            let res = await findAuctionCarInfo({ carId: payload.carId, type: payload?.type })
            if (res.success || res.code == 200) {
                commit('GET_CAR_DETAIL', {
                    ...res.entity,
                    // auctionStatus: 0
                })
            } else {
                // 存储空数据
                commit('GET_CAR_DETAIL', {})
            }
        } catch (error) {
            Message.error(error.message)
            commit('GET_CAR_DETAIL', {})
            commit('SET_LOADING', false);
        } finally {
            commit('SET_LOADING', false);
        }
    },
    // 存储侧边栏的数据
    async handleGetCarList({ commit, dispatch }, payload) {
        commit('SET_LOADING', true);
        try {
            let res = await getCarList({
                currentPage: payload.currentPage,
                pageSize: payload.pageSize,
                auctionId: payload.auctionId,
            })
            if (res.success || res.code == 200) {
                let list = res.pageInfo.list.map(item => {
                    // 现在的carImg是字符串是用逗号隔开的，需要转换成数组
                    return {
                        ...item,
                        img: item?.carPhoto?.split(",")[0] || '',
                    }
                })
                await commit('SET_TOTAL', res.pageInfo.total)
                await commit('GET_CAR_DETAIL_SIDE', list)
                if (!payload.carUpbeatId) return
            } else {
                // 存储空数据
                commit('GET_CAR_DETAIL_SIDE', [])
            }
        } catch (error) {
            commit('GET_CAR_DETAIL_SIDE', [])
            Message.error(error.message)
            commit('SET_LOADING', false);
        } finally {
            commit('SET_LOADING', false);
        }

    },

}
const getters = {
    isLoading: (state) => state.isLoading,
    total: (state) => state.total,
}
export default {
    state,
    getters,
    mutations,
    actions
}